// Path: frappe-bench/apps/knest_extrusion/knest_extrusion/public/js/knest_theme.js
(() => {
  // version marker — type `__knest_theme` in the browser console to confirm the
  // latest bundle is loaded (if it prints undefined/older, the tab has stale JS).
  try {
    window.__knest_theme = "sidebar-v2-2026-06-26";
  } catch (e) {}

  // ✅ Update these two only
  const BRAND_LOGO = "/assets/knest_extrusion/images/knest_ct_logo.png";
  const FAVICON = "/assets/knest_extrusion/images/knest-favicon.png"; // png preferred for favicon

  // ---------- helpers ----------
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function setImgSrc(el, src) {
    if (!el) return false;
    const cur = el.getAttribute("src") || "";
    if (cur === src) return false;
    el.setAttribute("src", src);
    return true;
  }

  function setFavicon(url) {
    const isSvg = url.toLowerCase().endsWith(".svg");
    const type = isSvg ? "image/svg+xml" : "image/png";

    const rels = [
      { rel: "icon", type },
      { rel: "shortcut icon", type },
      { rel: "apple-touch-icon" }, // no type needed
    ];

    rels.forEach(({ rel, type }) => {
      let link = document.querySelector(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        document.head.appendChild(link);
      }
      if (type) link.type = type;
      link.href = url;
    });
  }

  // Frappe persists "Full Width" in localStorage.container_fullwidth and applies it
  // at boot (desk.js) + via frappe.ui.toolbar.set_fullwidth_if_enabled().
  // We set it ON by DEFAULT (only when the user has never chosen), so the real
  // preference + the navbar toggle state stay consistent — and a user can still turn it off.
  function ensureFullWidth() {
    try {
      if (localStorage.container_fullwidth == null) {
        localStorage.container_fullwidth = "true";
      }
      // Let Frappe apply it so body class + menu reflect the same state (no race).
      if (window.frappe?.ui?.toolbar?.set_fullwidth_if_enabled) {
        frappe.ui.toolbar.set_fullwidth_if_enabled();
        return;
      }
    } catch (e) {
      // ignore
    }

    // Fallback before the toolbar is ready: apply class iff the flag is on.
    try {
      if (document.body && JSON.parse(localStorage.container_fullwidth || "false")) {
        document.body.classList.add("full-width");
      }
    } catch (e) {
      // ignore
    }
  }

  function applyBranding() {
    // 1) Desk top-left brand logo (your screenshot shows #brand-logo)
    setImgSrc(document.getElementById("brand-logo"), BRAND_LOGO);

    // 2) Sometimes Frappe re-renders using these containers/selectors
    $$("#brand-logo, .navbar-home img, .app-logo, img[alt='App Logo']").forEach((img) =>
      setImgSrc(img, BRAND_LOGO)
    );

    // 3) Login page logo (common variants)
    const loginCandidates = [
      "img.app-logo",
      "img[alt='App Logo']",
      ".page-card-head img",
      ".login-content img",
      ".web-footer ~ .container img", // rare
    ];
    loginCandidates.forEach((sel) => {
      const el = document.querySelector(sel);
      if (el) setImgSrc(el, BRAND_LOGO);
    });

    // 3b) Login page heading -> exact brand text ("Knest Extrusion ERP Login")
    const loginHeading = document.querySelector(".for-login .page-card-head h4");
    if (loginHeading && loginHeading.textContent.trim() !== "Extrusion ERP Login") {
      loginHeading.textContent = "Extrusion ERP Login";
    }

    // 3c) Support line inside the card.
    const loginCard = document.querySelector(".for-login .login-content.page-card");
    if (loginCard && !loginCard.querySelector(".knest-login-support")) {
      const support = document.createElement("div");
      support.className = "knest-login-support";
      support.innerHTML =
        'For support, mail to: <a href="mailto:erp.support@knestaluform.in">erp.support@knestaluform.in</a>';
      loginCard.appendChild(support);
    }
    // 3d) Credit block anchored to the bottom edge of the strip.
    const loginStrip = document.querySelector(".for-login");
    if (loginStrip && !loginStrip.querySelector(".knest-footer-credit")) {
      const credit = document.createElement("div");
      credit.className = "knest-footer-credit";
      credit.innerHTML =
        '<div class="knest-credit">© 2026 · Designed &amp; Developed by <b>Knest R&amp;D Team</b></div>' +
        '<div class="knest-powered">Powered by Frappe Framework</div>';
      loginStrip.appendChild(credit);
    }

    // 4) Favicon
    setFavicon(FAVICON);

    // 4b) Navbar Help menu: hide "Frappe Support" for all; "About" only for
    // System Managers / Administrator.
    const helpMenu = document.querySelector("#toolbar-help");
    if (helpMenu) {
      let isSysMgr = false;
      try {
        isSysMgr =
          (window.frappe?.user?.has_role &&
            frappe.user.has_role("System Manager")) ||
          window.frappe?.session?.user === "Administrator";
      } catch (e) {}
      helpMenu.querySelectorAll(".dropdown-item").forEach((el) => {
        const t = (el.textContent || "").trim().toLowerCase();
        if (t === "frappe support") el.style.display = "none";
        if (t === "about") el.style.display = isSysMgr ? "" : "none";
      });
    }

    // 5) Always full width
    ensureFullWidth();
  }

  // ---------- run strategy (desk renders async) ----------
  let scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyBranding();
    });
  }

  // Run ASAP
  scheduleApply();

  // After DOM ready
  document.addEventListener("DOMContentLoaded", () => {
    scheduleApply();

    // a few retries for slow first render
    let n = 0;
    const t = setInterval(() => {
      scheduleApply();
      if (++n >= 10) clearInterval(t);
    }, 400);
  });

  // Desk route changes
  if (window.frappe?.router?.on) {
    frappe.router.on("change", scheduleApply);
  }

  // After ajax updates (desk)
  if (window.frappe?.after_ajax) {
    frappe.after_ajax(scheduleApply);
  }

  // Watch DOM changes (navbar/sidebar re-render)
  const startObserver = () => {
    if (!document.body) return setTimeout(startObserver, 50);
    const obs = new MutationObserver(scheduleApply);
    obs.observe(document.body, { childList: true, subtree: true });
  };
  startObserver();
})();
/* ── Smart onload defaults for Extrusion operational forms (audit 2026-09-10) ──
   date -> today, shift -> current, operator -> the user's Employee.
   Public frappe.ui.form.on API — merges with each form's own onload handler. */
(function () {
  if (!window.frappe || !frappe.ui || !frappe.ui.form) return;
  window.knest_current_shift = function () {
    var h = new Date().getHours();
    return h >= 6 && h < 14 ? "A" : h >= 14 && h < 22 ? "B" : "C";
  };
  window.knest_set_current_employee = function (frm, field) {
    if (!field || frm.doc[field]) return;
    frappe.db.get_value("Employee", { user_id: frappe.session.user }, "name").then(function (r) {
      if (r && r.message && r.message.name) frm.set_value(field, r.message.name);
    });
  };
  var MAP = {
    "Casting Log": ["date", "shift", "operator"],
    "Homogenizing Cycle Log": ["date", "", ""],
    "Press Production Slip - Shift Log": ["slip_date", "shift", "operator"],
    "Aging Cycle Log": ["cycle_date", "", ""],
    "Surface Finishing Log": ["date", "shift", "operator"],
    "Packing Log": ["date", "shift", "operator"],
    "Die Usage Log": ["log_date", "shift", ""],
    "Machine Maintenance Log": ["date", "", "reported_by"],
    "Ascona Inspection Log": ["inspection_date", "shift", "operator"],
    "Mill Test Certificate": ["certificate_date", "", ""],
    "Finished Goods Receipt Note": ["posting_date", "", "operator"],
    "Internal Material Transfer Note": ["posting_date", "", ""],
    "Basket": ["basket_date", "", "store_operator"],
    "Nesting Plan": ["plan_date", "", ""],
    "Extrusion Non-Conformance": ["date", "", "reported_by"]
  };
  Object.keys(MAP).forEach(function (dt) {
    var m = MAP[dt];
    frappe.ui.form.on(dt, {
      onload: function (frm) {
        if (!frm.is_new()) return;
        if (m[0] && !frm.doc[m[0]]) frm.set_value(m[0], frappe.datetime.get_today());
        if (m[1] && !frm.doc[m[1]]) frm.set_value(m[1], window.knest_current_shift());
        if (m[2]) window.knest_set_current_employee(frm, m[2]);
      }
    });
  });
})();
